import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  jsonReader2agwreccj3lmk as jsonReader,
  jsonReaderkr2c3w0efm9b as jsonReader_0,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import {
  toApolloResponse9u5mcqg84l2p as toApolloResponse,
  parseResponse2l74cu4whks78 as parseResponse,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { Token_NULL_getInstancepc9ujj0oty64 as Token_NULL_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReader.mjs';
import { readErrors1y0wtxnlur21l as readErrors } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/internal/ResponseParser.mjs';
import {
  RouterError3i6hxcnqsy5l3 as RouterError,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
  ApolloHttpException3o30u8ntkffuh as ApolloHttpException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  flowOf16f7h10nre075 as flowOf,
  flow3tazazxj2t7g4 as flow,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  multipartBodyFlow272n2l39kgnug as multipartBodyFlow,
  get_isGraphQLResponse3ogjhw8yzfes1 as get_isGraphQLResponse,
  get_isMultipart1je26zsopcnca as get_isMultipart,
} from '../../internal/multipart.mjs';
import { catchrcnx5mlu3pkp as catch_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { currentTimeMillis8vwamy6polhm as currentTimeMillis } from '../../../../../../apollo-kotlin-apollo-mpp-utils/com/apollographql/apollo/mpp/utils.mjs';
import { HttpInfo25xgxbxy3emkc as HttpInfo } from './HttpExecutionContext.mjs';
import {
  dispose2t7a37uqicel0 as dispose,
  HttpInterceptor2khzkwmar9lg6 as HttpInterceptor,
  DefaultHttpInterceptorChain22k3s5gesb9pu as DefaultHttpInterceptorChain,
} from './HttpInterceptor.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstance6abcr423wmp1 as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { DefaultHttpRequestComposer3cbqxfvy17yg2 as DefaultHttpRequestComposer } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
import { DefaultHttpEngine26xguluicr03l as DefaultHttpEngine } from './DefaultHttpEngine.js.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { emitAll14ajoawrvg9d0 as emitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
function HttpNetworkTransport$execute$slambda$o$collect$slambda() {
  if (HttpNetworkTransport$execute$slambda$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
        this.z6e_1 = $$this$unsafeFlow;
        this.a6f_1 = this$0;
        this.b6f_1 = $request;
        this.c6f_1 = $httpResponse;
        this.d6f_1 = $millisStart;
      }
      *h1i(value, $completion) {
        var $this$transform = this.z6e_1;
        var tmp$ret$1 = withHttpInfo(this.a6f_1, value, this.b6f_1.s44_1, this.c6f_1, this.d6f_1);
        yield* $this$transform.a1e(tmp$ret$1, $completion);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.h1i(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambda$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
}
function HttpNetworkTransport$execute$slambda$o$collect$slambda_0($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
  var i = new (HttpNetworkTransport$execute$slambda$o$collect$slambda())($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart);
  var l = (value, $completion) => i.h1i(value, $completion);
  l.$arity = 1;
  return l;
}
var HttpNetworkTransport$execute$2$$inlined$map$1Class;
function HttpNetworkTransport$execute$2$$inlined$map$1() {
  if (HttpNetworkTransport$execute$2$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, this$0, $request, $httpResponse, $millisStart) {
        this.e6f_1 = $this;
        this.f6f_1 = this$0;
        this.g6f_1 = $request;
        this.h6f_1 = $httpResponse;
        this.i6f_1 = $millisStart;
      }
      *z1d(collector, $completion) {
        var tmp = HttpNetworkTransport$execute$slambda$o$collect$slambda_0(collector, this.f6f_1, this.g6f_1, this.h6f_1, this.i6f_1);
        yield* this.e6f_1.d1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      d1d(collector, $completion) {
        return this.z1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$execute$2$$inlined$map$1Class = $;
  }
  return HttpNetworkTransport$execute$2$$inlined$map$1Class;
}
var HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
function HttpNetworkTransport$multipleResponses$o$collect$slambda() {
  if (HttpNetworkTransport$multipleResponses$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
        this.j6f_1 = $$this$unsafeFlow;
        this.k6f_1 = $operation;
        this.l6f_1 = $request;
        this.m6f_1 = $customScalarAdapters;
        this.n6f_1 = this$0;
        this.o6f_1 = $incrementalResultsMerger;
      }
      *h1i(value, $completion) {
        var tmp0 = this.j6f_1;
        $l$block: {
          var tmp;
          var tmp_0 = this.k6f_1;
          if (isInterface(tmp_0, Subscription())) {
            // Inline function 'kotlin.apply' call
            var this_0 = jsonReader_0(value);
            var tmp0_elvis_lhs = this.l6f_1.b45_1;
            this_0.n4g(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
            var reader = this_0;
            var payloadResponse = null;
            var errors = null;
            reader.f42();
            while (reader.q1()) {
              switch (reader.h42()) {
                case 'payload':
                  if (reader.w41().equals(Token_NULL_getInstance())) {
                    reader.v41();
                  } else {
                    payloadResponse = parseResponse(reader, this.k6f_1, VOID, this.m6f_1, null);
                  }

                  break;
                case 'errors':
                  if (reader.w41().equals(Token_NULL_getInstance())) {
                    reader.v41();
                  } else {
                    errors = readErrors(reader);
                  }

                  break;
                default:
                  reader.v41();
                  break;
              }
            }
            reader.g42();
            var tmp_1;
            if (!(errors == null)) {
              tmp_1 = errorResponse(this.n6f_1, this.k6f_1, RouterError().f4i(errors));
            } else if (!(payloadResponse == null)) {
              tmp_1 = payloadResponse;
            } else {
              tmp_1 = null;
            }
            tmp = tmp_1;
          } else {
            if (this.o6f_1._v == null) {
              this.o6f_1._v = this.n6f_1.v6f_1.s6d();
            }
            var merged = this.o6f_1._v.d6e(value);
            var deferredFragmentIdentifiers = this.o6f_1._v.a6e();
            var isLast = !this.o6f_1._v.b6e();
            var tmp_2;
            if (this.o6f_1._v.c6e()) {
              tmp_2 = null;
            } else {
              tmp_2 = toApolloResponse(jsonReader(merged), this.k6f_1, VOID, this.m6f_1, deferredFragmentIdentifiers).h45().y45(isLast).l38();
            }
            tmp = tmp_2;
          }
          var tmp0_elvis_lhs_0 = tmp;
          var tmp_3;
          if (tmp0_elvis_lhs_0 == null) {
            break $l$block;
          } else {
            tmp_3 = tmp0_elvis_lhs_0;
          }
          var transformed = tmp_3;
          yield* tmp0.a1e(transformed, $completion);
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.h1i(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$o$collect$slambda_0($$this$unsafeFlow, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
  var i = new (HttpNetworkTransport$multipleResponses$o$collect$slambda())($$this$unsafeFlow, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger);
  var l = (value, $completion) => i.h1i(value, $completion);
  l.$arity = 1;
  return l;
}
function errorResponse($this, operation, throwable) {
  var tmp;
  if (throwable instanceof ApolloException()) {
    tmp = throwable;
  } else {
    tmp = ApolloNetworkException().b4b('Error while reading JSON response', throwable);
  }
  var apolloException = tmp;
  var tmp0_requestUuid = uuid4();
  return Builder().s45(operation, tmp0_requestUuid).x45(apolloException).y45(true).l38();
}
function errorResponse_0($this, operation, httpResponse) {
  var tmp;
  if ($this.s6f_1) {
    tmp = httpResponse.g4d();
  } else {
    var tmp0_safe_receiver = httpResponse.g4d();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l6();
    }
    tmp = null;
  }
  var maybeBody = tmp;
  var apolloException = ApolloHttpException().z4h(httpResponse.b4d_1, httpResponse.c4d_1, maybeBody, 'Http request failed with status code `' + httpResponse.b4d_1 + '`');
  return flowOf(errorResponse($this, operation, apolloException));
}
function singleResponse($this, request, customScalarAdapters, httpResponse) {
  var operation = request.r44_1;
  // Inline function 'kotlin.apply' call
  var this_0 = jsonReader_0(ensureNotNull(httpResponse.g4d()));
  var tmp0_elvis_lhs = request.b45_1;
  this_0.n4g(tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs);
  var response = toApolloResponse(this_0, operation, VOID, customScalarAdapters, null).h45().t45(httpResponse.f4d_1).l38();
  return flowOf(response.h45().y45(true).l38());
}
function multipleResponses($this, request, customScalarAdapters, httpResponse) {
  var incrementalResultsMerger = {_v: null};
  var operation = request.r44_1;
  // Inline function 'kotlinx.coroutines.flow.mapNotNull' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = multipartBodyFlow(httpResponse);
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp = new (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1())(this_0, operation, request, customScalarAdapters, $this, incrementalResultsMerger);
  return catch_0(tmp, HttpNetworkTransport$multipleResponses$slambda_0(operation, $this));
}
function wrapIfNeeded($this, $receiver) {
  var tmp;
  if ($receiver instanceof ApolloException()) {
    tmp = $receiver;
  } else {
    tmp = ApolloNetworkException().b4b('Error while reading response', $receiver);
  }
  return tmp;
}
function withHttpInfo($this, $receiver, requestUuid, httpResponse, millisStart) {
  // Inline function 'kotlin.apply' call
  var this_0 = $receiver.h45().b44(requestUuid);
  if (!(httpResponse == null)) {
    this_0.t45(new (HttpInfo())(millisStart, currentTimeMillis(), httpResponse.b4d_1, httpResponse.c4d_1));
  }
  return this_0.l38();
}
var EngineInterceptorClass;
function EngineInterceptor() {
  if (EngineInterceptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.w6f_1 = $outer;
      }
      *v6e(request, chain, $completion) {
        return yield* this.w6f_1.q6f_1.q6e(request, $completion);
      }
    }
    protoOf($).xz = dispose;
    initMetadataForClass($, 'EngineInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    EngineInterceptorClass = $;
  }
  return EngineInterceptorClass;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.b6a_1 = null;
        this.c6a_1 = null;
        this.d6a_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.e6a_1 = ArrayList().p2();
        this.f6a_1 = false;
        this.g6a_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.h6a_1 = ArrayList().p2();
      }
      i6a(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.c6a_1 = serverUrl;
        return this;
      }
      k6a(exposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.f6a_1 = exposeErrorBody;
        return this;
      }
      j6a(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.d6a_1 = httpEngine;
        return this;
      }
      l6a(interceptors) {
        // Inline function 'kotlin.apply' call
        this.e6a_1.a5();
        this.e6a_1.u2(interceptors);
        return this;
      }
      l38() {
        // Inline function 'kotlin.check' call
        if (!(this.b6a_1 == null || this.c6a_1 == null)) {
          var message = "It is an error to set both 'httpRequestComposer' and 'serverUrl'";
          throw IllegalStateException().o(toString(message));
        }
        var tmp0_elvis_lhs = this.b6a_1;
        var composer = tmp0_elvis_lhs == null ? DefaultHttpRequestComposer().c4c(this.c6a_1) : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.h6a_1.n1()) {
          this.e6a_1.i2(new (TransportHeadersInterceptor())(this.h6a_1));
        }
        var tmp1_elvis_lhs = this.d6a_1;
        return new (HttpNetworkTransport())(composer, tmp1_elvis_lhs == null ? DefaultHttpEngine() : tmp1_elvis_lhs, this.e6a_1, this.f6a_1, this.g6a_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var TransportHeadersInterceptorClass;
function TransportHeadersInterceptor() {
  if (TransportHeadersInterceptorClass === VOID) {
    class $ {
      constructor(headers) {
        this.x6f_1 = headers;
      }
      *v6e(request, chain, $completion) {
        return yield* chain.y6e(request.n4d().l4c(this.x6f_1).l38(), $completion);
      }
    }
    protoOf($).xz = dispose;
    initMetadataForClass($, 'TransportHeadersInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    TransportHeadersInterceptorClass = $;
  }
  return TransportHeadersInterceptorClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.y6f_1 = function_0;
      }
      *a1e(value, $completion) {
        return yield* this.y6f_1(value, $completion);
      }
      i5() {
        return this.y6f_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
function sam$kotlinx_coroutines_flow_FlowCollector$0_0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.z6f_1 = function_0;
      }
      *a1e(value, $completion) {
        return yield* this.z6f_1(value, $completion);
      }
      i5() {
        return this.z6f_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
}
var HttpNetworkTransport$execute$slambdaClass;
function HttpNetworkTransport$execute$slambda() {
  if (HttpNetworkTransport$execute$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $httpRequest, $request, $customScalarAdapters) {
        this.a6g_1 = this$0;
        this.b6g_1 = $httpRequest;
        this.c6g_1 = $request;
        this.d6g_1 = $customScalarAdapters;
      }
      *c6c($this$flow, $completion) {
        var millisStart = currentTimeMillis();
        var throwable = null;
        var tmp;
        try {
          tmp = yield* (new (DefaultHttpInterceptorChain())(plus(this.a6g_1.r6f_1, this.a6g_1.u6f_1), 0)).y6e(this.b6g_1, $completion);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var t = $p;
            if (t instanceof CancellationException()) {
              throw t;
            }
            throwable = t;
            tmp_0 = null;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        var httpResponse = tmp;
        var tmp_1;
        if (httpResponse == null) {
          tmp_1 = flowOf(errorResponse(this.a6g_1, this.c6g_1.r44_1, ensureNotNull(throwable)));
        } else {
          var tmp_2;
          var containsArg = httpResponse.b4d_1;
          if (!(200 <= containsArg ? containsArg <= 299 : false)) {
            tmp_2 = !get_isGraphQLResponse(httpResponse);
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp_1 = errorResponse_0(this.a6g_1, this.c6g_1.r44_1, httpResponse);
          } else {
            if (get_isMultipart(httpResponse)) {
              tmp_1 = multipleResponses(this.a6g_1, this.c6g_1, this.d6g_1, httpResponse);
            } else {
              tmp_1 = singleResponse(this.a6g_1, this.c6g_1, this.d6g_1, httpResponse);
            }
          }
        }
        var responses = tmp_1;
        // Inline function 'kotlinx.coroutines.flow.map' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp$ret$0 = new (HttpNetworkTransport$execute$2$$inlined$map$1())(responses, this.a6g_1, this.c6g_1, httpResponse, millisStart);
        yield* emitAll($this$flow, tmp$ret$0, $completion);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.c6c((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambdaClass;
}
function HttpNetworkTransport$execute$slambda_0(this$0, $httpRequest, $request, $customScalarAdapters) {
  var i = new (HttpNetworkTransport$execute$slambda())(this$0, $httpRequest, $request, $customScalarAdapters);
  var l = ($this$flow, $completion) => i.c6c($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
function HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1() {
  if (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class === VOID) {
    class $ {
      constructor($this, $operation, $request, $customScalarAdapters, this$0, $incrementalResultsMerger) {
        this.e6g_1 = $this;
        this.f6g_1 = $operation;
        this.g6g_1 = $request;
        this.h6g_1 = $customScalarAdapters;
        this.i6g_1 = this$0;
        this.j6g_1 = $incrementalResultsMerger;
      }
      *z1d(collector, $completion) {
        var tmp = HttpNetworkTransport$multipleResponses$o$collect$slambda_0(collector, this.f6g_1, this.g6g_1, this.h6g_1, this.i6g_1, this.j6g_1);
        yield* this.e6g_1.d1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0_0())(tmp), $completion);
        return Unit_instance;
      }
      d1d(collector, $completion) {
        return this.z1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class = $;
  }
  return HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
}
var HttpNetworkTransport$multipleResponses$slambdaClass;
function HttpNetworkTransport$multipleResponses$slambda() {
  if (HttpNetworkTransport$multipleResponses$slambdaClass === VOID) {
    class $ {
      constructor($operation, this$0) {
        this.k6g_1 = $operation;
        this.l6g_1 = this$0;
      }
      *m6g($this$catch, throwable, $completion) {
        yield* $this$catch.a1e(Builder().s45(this.k6g_1, uuid4()).x45(wrapIfNeeded(this.l6g_1, throwable)).l38(), $completion);
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.m6g(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpNetworkTransport$multipleResponses$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$slambda_0($operation, this$0) {
  var i = new (HttpNetworkTransport$multipleResponses$slambda())($operation, this$0);
  var l = ($this$catch, throwable, $completion) => i.m6g($this$catch, throwable, $completion);
  l.$arity = 2;
  return l;
}
var HttpNetworkTransportClass;
function HttpNetworkTransport() {
  if (HttpNetworkTransportClass === VOID) {
    class $ {
      constructor(httpRequestComposer, engine, interceptors, exposeErrorBody, incrementalDeliveryProtocol) {
        this.p6f_1 = httpRequestComposer;
        this.q6f_1 = engine;
        this.r6f_1 = interceptors;
        this.s6f_1 = exposeErrorBody;
        this.t6f_1 = incrementalDeliveryProtocol;
        this.u6f_1 = new (EngineInterceptor())(this);
        this.v6f_1 = get_impl(this.t6f_1);
      }
      p6b(request) {
        var customScalarAdapters = ensureNotNull(request.t44_1.q49(Key_getInstance()));
        var tmp;
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs = request.w44_1;
        var tmp0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'kotlin.collections.none' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.n1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$1 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            if (element.t4c_1.toLowerCase() === 'accept') {
              tmp$ret$1 = false;
              break $l$block_0;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          var tmp_1;
          var tmp_2 = request.r44_1;
          if (isInterface(tmp_2, Subscription())) {
            tmp_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
          } else {
            tmp_1 = this.v6f_1.r6d();
          }
          var accept = tmp_1;
          tmp = request.h45().h44('accept', accept).l38();
        } else {
          tmp = request;
        }
        var request_0 = tmp;
        var httpRequest = this.p6f_1.d4c(request_0);
        return this.n6g(request_0, httpRequest, customScalarAdapters);
      }
      n6g(request, httpRequest, customScalarAdapters) {
        return flow(HttpNetworkTransport$execute$slambda_0(this, httpRequest, request, customScalarAdapters));
      }
      xz() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.r6f_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.xz();
        }
        this.q6f_1.l6();
      }
    }
    initMetadataForClass($, 'HttpNetworkTransport');
    HttpNetworkTransportClass = $;
  }
  return HttpNetworkTransportClass;
}
//region block: exports
export {
  Builder_0 as Builder3d75eph7uovs3,
};
//endregion

//# sourceMappingURL=HttpNetworkTransport.mjs.map
